'use strict';

var ExceptionHandlerProvider = function ExceptionHandlerProvider() {
  this.config = {
    appErrorPrefix: 'AVRO-UI: '
  };
  this.configure = function (appErrorPrefix) {
    this.config.appErrorPrefix = appErrorPrefix;
  };
  this.$get = function () {
    return {
      config: this.config
    };
  };
};
ExceptionHandlerProvider.$inject = [];
module.exports = ExceptionHandlerProvider;